/** Small display formatters shared across screens. */

const EM_DASH = "—";

/** "12.5" → "12.5%"; null/undefined → "—". */
export function formatPct(value: number | null | undefined): string {
  return value == null ? EM_DASH : `${value}%`;
}

/** ISO date/datetime → "17 Jul 2026"; null → "—". */
export function formatDate(value: string | null | undefined): string {
  if (!value) return EM_DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

/** ISO datetime → "17 Jul 2026, 14:32"; null → "—". */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return EM_DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Nett/list money → "£1,234.56" (always 2dp); null/undefined → "—". */
export function formatMoney(value: number | null | undefined): string {
  if (value == null) return EM_DASH;
  return value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** AI cost → "$0.0123" (up to 4dp — sub-cent costs matter); null → "—". */
export function formatUsd(value: number | null | undefined): string {
  if (value == null) return EM_DASH;
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
}

/** 0-1 confidence → "82%"; null → "—". */
export function formatConfidence(value: number | null | undefined): string {
  if (value == null) return EM_DASH;
  return `${Math.round(value * 100)}%`;
}

/** Integer count with thousands separators; null → "—". */
export function formatInt(value: number | null | undefined): string {
  if (value == null) return EM_DASH;
  return value.toLocaleString("en-GB");
}

/** Best human message for an unknown thrown value. */
export function errorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  return "Something went wrong";
}
